import * as React from 'react'
import { useMemo } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import type { EditPencilProps } from './EditPencil'
import { useGetLeadOppProductsOnMount } from '@user/store/leadOppProducts'
import { EditLeadNameFormWrapper } from './EditLeadNameFormWrapper'
import { EditOpportunityNameFormWrapper } from './EditOpportunityNameFormWrapper'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

type Props = EditPencilProps & {
  onClose: () => void
}

export function EditPencilContent(props: Props) {
  const {
    entityType,
    detail: { id },
  } = props

  const status = useGetLeadOppProductsOnMount(id, entityType)
  const loading = status === 'pending'

  const content = useMemo(() => {
    switch (props.entityType) {
      case ENTITY_TYPES.Lead:
        return <EditLeadNameFormWrapper {...props} />
      case ENTITY_TYPES.Opportunity:
        return <EditOpportunityNameFormWrapper {...props} />
    }
  }, [props])

  return (
    <Box
      p={2}
      display="flex"
      minWidth={490}
      minHeight={260}
      alignItems="center"
    >
      {loading ? <CircularProgress sx={{ margin: 'auto' }} /> : content}
    </Box>
  )
}
